export default {
  default: () => import("/Users/infamus/Projects/compass_app/compass_frontend/layouts/default.vue")
}